const JUMP_VEL = 1400;
const GRAVITY = 3000;

const STATE_RUN = 2;
const STATE_EXIT = 3;

export default class Follower extends Phaser.Group {
  constructor(game, x, y, charData, leader, offsetMax, delay) {
    super(game);

    //
    this.ANIM_RUN = 'run';
    this.ANIM_JUMP = 'jump';

    this.SIZES = {
      jump: { dx: 0, dy: -100 },
      run: { dx: 0, dy: 0 },
    };

    this.x = this.destX = x;
    this.y = this.groundY = y;
    this.leader = leader;
    this.offsetMax = offsetMax;
    this.delay = delay;
    this.depth = charData.depth;

    this.state = STATE_RUN;

    this.positions = [];

    this.m_animId = '';

    this.m_asset = this.game.make.sprite(0, 0, 'chasegame_char_' + charData.id);
    this.m_asset.anchor.set(0.5, 1);

    let frames = charData.id == 'scooby' ? 8 : 16;
    this.m_asset.animations.add(
      'run',
      Phaser.Animation.generateFrameNames('run_', 1, frames, '', 4),
      24,
      true,
      false
    );
    this.m_asset.animations.add('jump', ['jump_0001', 'jump_0002'], 24, false, false);
    this.m_asset.animations.add('fall', ['jump_0003', 'jump_0003'], 24, false, false);
    this.addChild(this.m_asset);

    this.setAnim(this.ANIM_RUN);
  }

  destroy() {
    this.m_asset.animations.stop();
    this.m_asset = null;
    super.destroy();
  }

  pause() {
    this.m_asset.animations.paused = true;
  }

  resume() {
    this.m_asset.animations.paused = false;
  }

  setAnim(animId) {
    if (this.m_animId != animId) {
      this.m_animId = animId;
      this.m_asset.play(animId);

      this.m_size = this.SIZES[animId];

      //this.y += this.m_size.dy;

      // if (animId == 'run') {
      //   this.m_asset.y = 0;
      // } else {
      //   this.m_asset.y = -100;
      // }
    }
  }

  exit() {
    this.state = STATE_EXIT;
  }

  step(dt) {
    // get leader position

    let t = this.game.time.time - this.delay;
    let positions = this.leader.positions.filter((p) => p.t > t);
    if (positions.length > 0) {
      let p = positions[0];
      let offset = (p.speed * this.delay) / 1000;
      offset = Math.min(this.offsetMax, offset);
      this.destX = p.x - offset;
      this.y = p.y;
      this.speedX = p.speed;
      this.setAnim(p.anim);
      this.alpha = p.alpha;
    }
    if (this.state == STATE_RUN) {
      this.x += (this.destX - this.x) * 0.5;
    } else if (this.state == STATE_EXIT) {
      this.x += this.speedX * dt;
    }

    // shadow
    let factor = 1 - Math.min(1, Math.abs((this.y - this.groundY) / 200));
    this.shadow.scale.set(factor);
    this.shadow.alpha = factor;
    this.shadow.x = this.x;
    this.shadow.y = this.groundY;

    //
    this.savePosition();
  }

  savePosition() {
    let pos = {
      x: this.x,
      y: this.y,
      anim: this.m_animId,
      t: this.game.time.time,
      speed: this.speedX,
      alpha: this.alpha,
    };

    this.positions.push(pos);
    this.positions = this.positions.filter((p) => p.t > pos.t - 500);
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/objects/Follower.js